// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { HighlightBox } from '@tectonics/look-and-feel/volcanes/atoms';

import { TicketDetails } from './ticket-details';
import { TicketAmount } from './ticket-amount';
import { TicketApprovalDate } from '@tectonics/look-and-feel/volcanes/pages/page-confirmed-payment/page-content/achpse-page/ticket-approval-date';

export function Ticket(): Node {
  return (
    <Root>
      <Grid>
        <GridSlot name="amount">
          <TicketAmount />
        </GridSlot>
        <GridSlot name="approval">
          <TicketApprovalDate/>
        </GridSlot>
      </Grid>
      <TicketDetails />
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;


const GridSlot = styled(HighlightBox)`
  grid-area: ${props => props.name};
`;

const Grid = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-areas: "amount approval";
  ${GridSlot} {
    border-style: none;
    border-radius: 0;
    &:nth-child(1) {
      border-top-left-radius: 5px;
      border-style: solid none none solid;
    }
    &:nth-child(2) {
      border-top-right-radius: 5px;
      border-style: solid solid none solid;
    }
    &:nth-child(3) {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      border-style: solid;
    }
  }
`;
